module.exports = __webpack_public_path__ + "fonts/Jost-500-Medium.e7d6699.otf";